import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { SectionEyebrow } from "./SectionEyebrow";
import { buildLocalizedPath } from "../lib/langRoutes";

/**
 * Homepage prices block — shows the transparent-pricing promise and a
 * CTA to the dedicated prices page. The actual numeric table lives only on
 * the dedicated /preise (DE) · /precos (PT) · /prices (EN) route.
 */
export const HomePrices = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language?.split("-")[0] || "de";
  const pricesPath = buildLocalizedPath("prices", lang);

  return (
    <section
      id="home-prices"
      data-testid="home-prices-section"
      className="py-24 lg:py-32 bg-[#F6F5F2] relative overflow-hidden"
    >
      <div className="absolute top-1/2 -translate-y-1/2 -left-32 w-96 h-96 rounded-full bg-[#A7CA99]/10 blur-3xl pointer-events-none" />

      <div className="relative max-w-3xl mx-auto px-6 md:px-12 text-center">
        <SectionEyebrow num="04" align="center">{t("homeprices.eyebrow")}</SectionEyebrow>
        <h2
          data-testid="home-prices-headline"
          className="font-serif text-4xl lg:text-5xl xl:text-6xl font-light tracking-tight leading-[1.05] text-[#3E5239]"
        >
          {t("homeprices.title_l1")}{" "}
          <span className="italic text-[#A7CA99]">{t("homeprices.title_l2")}</span>
        </h2>
        <p
          data-testid="home-prices-promise"
          className="mt-8 text-base lg:text-lg text-[#6B7A66] font-light leading-relaxed"
        >
          {t("homeprices.promise")}
        </p>
        <div className="mt-10">
          <Link
            to={pricesPath}
            data-testid="home-prices-see-all"
            className="inline-flex items-center gap-3 px-8 py-4 bg-[#3E5239] text-[#F6F5F2] text-xs uppercase tracking-[0.22em] hover:bg-[#A7CA99] hover:text-[#1F2D1D] rounded-sm transition-all shadow-md hover:shadow-lg hover:-translate-y-0.5"
          >
            {t("homeprices.view_reference")}
          </Link>
        </div>
      </div>
    </section>
  );
};
